// Dependencies
import React, { useState, useCallback, useEffect } from "react";
import { Global, css } from "@emotion/core";
import AppRouter from "./AppRouter";
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale-provider/es_ES";
import moment from "moment";
import "moment/locale/es";
import UserContext from "../context/User/UserContext";
import { get } from "../api/apiInstance";

// Store
moment.locale("es");

const globalCss = `
  .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: rgba(24, 144, 255, 0.8) !important;
    color: white !important;
  }
`;

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDataUser = useCallback(() => {
    get("/check")
      .then(({ data }) => {
        if (data.isAuthenticated && data.user) {
          setUser(data.user);
          setLoading(false);
        }
      })
      .catch((err) => {
        setUser(null);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchDataUser();
  }, [fetchDataUser]);

  return loading ? (
    <div>Cargando...</div>
  ) : (
    <ConfigProvider locale={esES}>
      <UserContext.Provider value={{ user, setUser }}>
        <Global styles={css(globalCss)} />
        <AppRouter />
      </UserContext.Provider>
    </ConfigProvider>
  );
};

export default App;
